import { render, staticRenderFns } from "./BrandingSettings.vue?vue&type=template&id=5c137f92&"
import script from "./BrandingSettings.vue?vue&type=script&lang=js&"
export * from "./BrandingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports